import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import ShareButtons from "./ShareButtons";

export default function ArticleCard({ article, featured = false }) {
  if (!article || !article.id) return null;
  
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "";
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  const title = article.title || "Sem título";
  const excerpt = article.excerpt || "";
  const category = article.category || "Notícias";
  const views = article.views ?? 0;
  const hasImage = article.image_url && article.image_url.length > 1;

  const imageBlock = (maxH) => hasImage ? (
    <div className="relative w-full overflow-hidden bg-[#0a0a0a]">
      {/* Fundo borrado adaptativo (não corta a imagem principal) */}
      <img
        src={article.image_url}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-40 pointer-events-none"
        loading="lazy"
      />
      <img
        src={article.image_url}
        alt={title}
        loading="lazy"
        decoding="async"
        className="relative w-full object-contain mx-auto transition-transform duration-500 group-hover:scale-105"
        style={{ maxHeight: maxH, minHeight: "180px" }}
        onError={(e) => { e.target.style.display = "none"; }}
      />
      <div className="absolute top-3 left-3 z-10">
        <span className="category-pill">{category}</span>
      </div>
    </div>
  ) : null;

  if (featured) {
    return (
      <Link
        to={`/artigo/${article.id}`}
        className="group block bg-[#121212] rounded-2xl overflow-hidden border border-white/10 card-hover"
        data-testid={`featured-article-${article.id}`}
      >
        {imageBlock("500px")}
        <div className="p-6 md:p-8">
          {!hasImage && (
            <div className="mb-3">
              <span className="category-pill">{category}</span>
            </div>
          )}
          <h2 className="font-heading text-xl md:text-2xl font-bold text-white leading-tight mb-3 group-hover:text-[#FF007F] transition-colors line-clamp-2">
            {title}
          </h2>
          <p className="text-zinc-400 text-sm line-clamp-2 mb-4">
            {excerpt}
          </p>
          <div className="flex items-center gap-4 text-zinc-500 text-xs">
            <span>{formatDate(article.created_at)}</span>
            <span className="flex items-center gap-1">
              <Eye size={14} />
              {views}
            </span>
            <ShareButtons url={`/artigo/${article.id}`} title={title} />
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/artigo/${article.id}`}
      className="group block bg-[#121212] rounded-2xl overflow-hidden border border-white/10 card-hover"
      data-testid={`article-card-${article.id}`}
    >
      {imageBlock("400px")}
      <div className="p-5">
        {!hasImage && (
          <div className="mb-2">
            <span className="category-pill">{category}</span>
          </div>
        )}
        <h3 className="font-heading text-lg font-bold text-white leading-tight mb-2 group-hover:text-[#FF007F] transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-zinc-400 text-sm line-clamp-2 mb-4">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-zinc-500 text-xs">
          <span>{formatDate(article.created_at)}</span>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <Eye size={12} />
              {views}
            </span>
            <ShareButtons url={`/artigo/${article.id}`} title={title} />
          </div>
        </div>
      </div>
    </Link>
  );
}
